import React from 'react'

const LoadingView = () => (
    <div className="container py-4">
        <div className="row justify-content-center">
            <div className="col-12 col-md-6 text-center">
                <div className="d-flex justify-content-center">
                    <img
                        src="https://scheduler.shippersedge.com/loading.gif"
                        alt="Loading..."
                        height="150"
                        title="Loading"
                    />
                </div>
                <p className="mt-3 text-muted">Loading Shipment...</p>
            </div>
        </div>
    </div>
)

export default LoadingView
